export default __webpack_public_path__ + "static/media/shrimp-pasta-dish.97c8a920.jpg";